import PaginationTable from './NewPaginationTable';

export default PaginationTable;
